// Beaufort Wind Scale Classification
const ws_lookup = [
    [1, "Calm"],               // Force 0: 0-1 knots
    [3, "Light Air"],          // Force 1: 1-3 knots
    [6, "Light Breeze"],       // Force 2: 4-6 knots
    [10, "Gentle Breeze"],     // Force 3: 7-10 knots
    [16, "Moderate Breeze"],   // Force 4: 11-16 knots
    [21, "Fresh Breeze"],      // Force 5: 17-21 knots
    [27, "Strong Breeze"],     // Force 6: 22-27 knots
    [33, "Near Gale"],         // Force 7: 28-33 knots
    [40, "Gale"],             // Force 8: 34-40 knots
    [47, "Strong Gale"],       // Force 9: 41-47 knots
    [55, "Storm"],            // Force 10: 48-55 knots
    [63, "Violent Storm"],     // Force 11: 56-63 knots
    [1000, "Hurricane"]        // Force 12: 64+ knots
];

function lookupWindspeed(ws) {
    // Handle zero or negative values
    if (ws <= 0) return "Calm";

    for (let i = 0; i < ws_lookup.length; i++) {
        if (ws <= ws_lookup[i][0]) {
            return ws_lookup[i][1];
        }
    }
    return "Hurricane"; // Fallback for any values above our ranges
}

export default lookupWindspeed;